<template>
  <div id="order_history_list">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <h2>ご注文履歴</h2>
            <div class="history_list" v-for="(order,index) in productList" :key="'history-' + index">
              <dd-history
                :orderData="order"
                @detail="detail"
              />
            </div>
            <dd-pager
              :pageNo="pageNo"
              :dataCountPerPage="15"
              :totalDataCount="orderHistoryList.length"
              @paging="paging"
            />
            <div v-if="productList.length <= 0" class="not_history">ご注文履歴がありません。</div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'

import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcPager from '../components/common/DcPager'
import DcOrderHistory from '../components/order/DcOrderHistory'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

const PRODUCT_VIEW_SIZE = 15

export default {
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-history': DcOrderHistory,
    'dd-loading-modal': LoadingModal,
    'dd-pager': DcPager,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcOrderHistoryList',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'myPage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'orderHistoryList', key: 'dcOrderHistoryList', title: '注文履歴リスト', route: 'DcOrderHistoryList'}
      ],
      pageNo: 1
    }
  },
  computed: {
    ...mapState(
      {orderHistoryList: state => state.orderHistoryList}
    ),
    // 表示用商品リスト
    productList: function () {
      if (!this.orderHistoryList) return []
      let startIdx = (this.pageNo - 1) * PRODUCT_VIEW_SIZE
      let endIdx = this.pageNo * PRODUCT_VIEW_SIZE
      let list = this.orderHistoryList.filter(function (element, index) {
        return (index >= startIdx && index < endIdx)
      })
      return list
    }
  },
  methods: {
    ...mapActions({getOrderHistoryList: 'loadOrderHistoryList'}),
    paging: function (selPage) {
      this.pageNo = selPage
    },
    detail: function (orderNo) {
      this.$router.push({
        name: 'DcOrderHistoryDetail',
        params: { orderNo: orderNo }
      })
    }
  },
  mounted: function () {
    this.$store.dispatch('loadOrderHistoryList', {reload: true})
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcOrderHistoryList.vue